import { render, staticRenderFns } from "./zws-steps.vue?vue&type=template&id=077cd790&scoped=true"
import script from "./zws-steps.vue?vue&type=script&lang=js"
export * from "./zws-steps.vue?vue&type=script&lang=js"
import style0 from "./zws-steps.vue?vue&type=style&index=0&id=077cd790&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077cd790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077cd790')) {
      api.createRecord('077cd790', component.options)
    } else {
      api.reload('077cd790', component.options)
    }
    module.hot.accept("./zws-steps.vue?vue&type=template&id=077cd790&scoped=true", function () {
      api.rerender('077cd790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/zws-steps.vue"
export default component.exports